import { useEffect } from "react";
import { useImmer } from "use-immer";

import { fetchWithURL } from "src/apis/main";
import { getDisplayName } from "src/utils/common";

export default function withSeasons(WrappedComponent) {
  function WithSeasons({ url, ...others }) {
    const [seasons, setSeasons] = useImmer([]);
    const [selectedSeason, setSelectedSeason] = useImmer(null);

    useEffect(() => {
      fetchSeasons();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFetch = async (url) => {
      const response = await fetchWithURL(url);
      const { subitems } = response.data;
      return subitems;
    };

    const fetchSeasons = async () => {
      const subitems = await handleFetch(url);
      setSeasons(subitems);

      if (subitems.length > 0) {
        fetchEpisodes(subitems[0]);
      }
    };

    const fetchEpisodes = async (season) => {
      if (!season.episodes) {
        const subitems = await handleFetch(season.feedUrl);
        setSeasons((draft) => {
          draft.find((item) => item.contentId === season.contentId).episodes =
            subitems;
        });
        setSelectedSeason({ ...season, episodes: subitems });
      } else {
        setSelectedSeason(season);
      }
    };

    return (
      <WrappedComponent
        seasons={seasons}
        selectedSeason={selectedSeason}
        fetchEpisodes={fetchEpisodes}
        {...others}
      />
    );
  }

  WithSeasons.displayName = `WithSeasons(${getDisplayName(WrappedComponent)})`;
  return WithSeasons;
}
